import { render, staticRenderFns } from "./PledgedShareDetails.vue?vue&type=template&id=4f63e178&"
import script from "./PledgedShareDetails.vue?vue&type=script&lang=js&"
export * from "./PledgedShareDetails.vue?vue&type=script&lang=js&"
import style0 from "./PledgedShareDetails.vue?vue&type=style&index=0&id=4f63e178&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports